export default __webpack_public_path__ + "static/media/tic_tac_toe_preview.80740835.png";